var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex bg-soft rounded-lg p-0.5 gap-0.5 justify-center items-center"},_vm._l((_vm.buttonsProps),function(ref){
var tooltip = ref.tooltip;
var icon = ref.icon;
var key = ref.key;
var isDisabled = ref.isDisabled;
return _c('vx-tooltip',{key:key,attrs:{"text":tooltip,"position":"bottom"}},[_c('base-button',{attrs:{"variant":key === _vm.selectedButtonValue ? 'bordered-icon-group-active' : 'bordered-icon-group',"tooltip-text":tooltip,"disabled":isDisabled},on:{"click":function($event){_vm.selectedButtonValue = key}}},[_vm._t("default",null,{"slotIcon":icon})],2)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }